import * as React from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';
import constantsStorage from 'constants/Storage';
import UseChangeVenue from 'types/hooks/useChangeVenue';
import Venue from 'types/models/Venue';
import OrderContext from 'contexts/OrderContext';

export default (): UseChangeVenue => {
  const { setCurrentVenue } = React.useContext(OrderContext);

  const storeCurrentVenue = async (venue: Venue): Promise<void> => {
    try {
      await AsyncStorage.setItem(constantsStorage.currentVenue, JSON.stringify(venue));
      setCurrentVenue(venue);
    } catch (error) {
      console.log(error);
    }
  };

  const deleteCurrentVenue = async (): Promise<void> => {
    try {
      await AsyncStorage.removeItem(constantsStorage.currentVenue);
      setCurrentVenue(null);
    } catch (error) {
      console.log(error);
    }
  };

  return { storeCurrentVenue, deleteCurrentVenue };
};
